import {alpha, Theme} from "@mui/material/styles";
import {surveyControls} from "../surveyRunnerColors";

export const choiceSurfaceSx = (selected: boolean) => (theme: Theme) => ({
    border: '1px solid',
    borderColor: selected ? surveyControls(theme).accent : surveyControls(theme).border,
    borderRadius: 1,
    boxShadow: selected ? `inset 0 0 0 1px ${surveyControls(theme).accent}` : 'none',
    backgroundColor: selected
        ? alpha(theme.palette.primary.main, 0.12)
        : theme.palette.background.paper,
    transition: 'border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease',
    '&:hover': {
        borderColor: selected ? surveyControls(theme).accent : surveyControls(theme).hoverBorder,
        backgroundColor: alpha(theme.palette.primary.main, selected ? 0.16 : 0.05),
    },
    '&:focus-visible': {
        outline: `2px solid ${surveyControls(theme).focus}`,
        outlineOffset: 3,
    },
});
